export default __webpack_public_path__ + "static/logs_tab-96e9b52ba987645dea0eab3bdb56cfd1.png";